import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

const DefaultRoute = () => {
  const { hasPermission } = usePermissions();

  // Always redirect to dashboard as the main landing page
  if (hasPermission('dashboard.read')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Define fallback routes in order of priority
  const routes = [
    { path: '/inventory', permission: 'inventory.read' },
    { path: '/job-cards', permission: 'jobcards.read' },
    { path: '/customers', permission: 'customers.read' },
    { path: '/members', permission: 'members.read' },
    { path: '/vendors', permission: 'vendors.read' },
    { path: '/accounts', permission: ['accounts.read', 'invoices.read', 'quotations.read', 'payments.read'] },
    { path: '/schedule', permission: 'schedule.read' },
    { path: '/reports', permission: 'reports.read' },
    { path: '/crm', permission: 'crm.read' }
  ];

  // Find first accessible route
  for (const route of routes) {
    // Handle multiple permissions (any one is sufficient)
    if (Array.isArray(route.permission)) {
      if (route.permission.some(perm => hasPermission(perm))) {
        return <Navigate to={route.path} replace />;
      }
    } else {
      if (hasPermission(route.permission)) {
        return <Navigate to={route.path} replace />;
      }
    }
  }

  // If no other routes are accessible, redirect to dashboard anyway
  return <Navigate to="/dashboard" replace />;
};

export default DefaultRoute;